module.exports = __webpack_public_path__ + "img/NASH_m.b24f48be.png";